<template>
  <v-dialog v-model="dialog" max-width="420">
    <v-card>
      <v-card-title style="background-color: #36304a; color: aliceblue;">
        <h5><v-icon color="success" size="x-small" style="padding-bottom: 5px;">mdi-check</v-icon> {{ title }}</h5>   
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions style="background-color: #eedbf1">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" size="small" variant="flat" prepend-icon="mdi-cancel" @click="disagree">
          {{ options.btnDisagree }}
        </v-btn>
        <v-btn color="green darken-1" size="small" prepend-icon="mdi-check" variant="flat" @click="agree">
          {{ options.btnAgree }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ValidatePopup",
  data() {
    return {
      dialog: false,
      title: "",
      message: "",
      options: {
        btnDisagree: "Disagree",
        btnAgree: "Agree",
      },
      agreeCallback: null,
      disagreeCallback: null,
    };
  },
  methods: {
    open({
      title,
      message,
      options = {
        btnDisagree: "Disagree",
        btnAgree: "Agree",
      },
      agree = () => {},
      disagree = () => {},
    }) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = options;
      this.agreeCallback = agree;
      this.disagreeCallback = disagree;
    },
    disagree() {
      this.dialog = false;
      this.disagreeCallback();
    },
    agree() {
      this.dialog = false;
      this.agreeCallback();
    },
  },
};
</script>
